module.exports = __webpack_public_path__ + "static/img/icon-01.6061e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/four-pillars/icon-01.png
// module id = 9poR
// module chunks = 1